import { render, staticRenderFns } from "./MyPortalCollapse.vue?vue&type=template&id=770a966e&"
import script from "./MyPortalCollapse.vue?vue&type=script&lang=js&"
export * from "./MyPortalCollapse.vue?vue&type=script&lang=js&"
import style0 from "./MyPortalCollapse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports